























import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Provide, Watch } from "vue-property-decorator";
import { ContentSet, InputContentSetUpdate } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { Debounce } from "@/lib/decorators";
import { $t } from "@/lib/i18nHelpers";
import { PostFileData } from "@/types";
import CustomScroll from "@/components/CustomScroll";
import PageTitle from "@/components/PageTitle";
import EditPostOptions from "../EditPostOptions";
import EventPostEditView from "../EventPostEditView";
import InputWithMentions from "../InputWithMetions";
import MediaPostEditView from "../MediaPostEditView";

@Component({
  name: "EditPostOverview",
  components: {
    EditPostOptions,
    PageTitle,
    InputWithMentions,
    CustomScroll,
  },
})
export default class EditPostOverview extends Vue {
  @Prop({ required: true })
  public readonly postData!: ContentSet;

  @Prop({ required: true })
  public readonly fileList!: PostFileData[];

  public description: string = "";

  public updateCb: (() => Promise<void>)[] = [];

  public get type() {
    if (!this.postData) return "";
    return this.postData.type;
  }

  public get uploading() {
    return this.fileList.some(f => f.uploading);
  }

  public get component() {
    if (this.type === ContentFeedTypeEnum.EVENT) return EventPostEditView;
    return MediaPostEditView;
  }

  public get title() {
    return $t("{0} {1}", [
      !this.postData.published ? $t("New") : $t("Edit"),
      this.postData.type === ContentFeedTypeEnum.MEDIA ? $t("post") : $t("event"),
    ]);
  }

  @Debounce(1000, { leading: false })
  @Watch("description")
  public watchDescription(description: string) {
    const data: Omit<InputContentSetUpdate, "id"> = {
      description,
    };
    this.$emit("update", { data });
  }

  public onPublish(cb: Function) {
    const data: Omit<InputContentSetUpdate, "id"> = {
      description: this.description,
      published: true,
    };
    const update = () => Promise.all(this.updateCb.map(i => i()));
    this.$emit("update", { data, closeOnSave: true, beforeUpdate: update }, cb);
  }

  @Provide("setUpdateCb")
  public onSetUpdateCb(cb: () => Promise<void>) {
    this.updateCb.push(cb);
    this.$emit("onSetUpdateCb", cb);
  }

  @Provide("removeCb")
  public removeCb(cb: () => Promise<void>) {
    this.updateCb = this.updateCb.filter(i => i !== cb);
    this.$emit("onSetUpdateCb", cb);
  }

  public created() {
    this.description = this.postData.description ?? "";
  }
}
